// Use for icons
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import '../../styles/SearchBox.scss';

/* todo replace after stencil migration, display */
export const IconFromSVG = ({ src, width, marginRight, display }) => (
  <img
    style={{ width, marginRight, display }}
    src={src}
    alt="example.png"
    width="50px"
    height="50px"
  />
);
IconFromSVG.propTypes = {
  src: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  marginRight: PropTypes.string,
  display: PropTypes.string
};

IconFromSVG.defaultProps = {
  marginRight: '',
  display: 'initial'
};
